module.exports = __webpack_public_path__ + "static/media/mockup-prime@2x.9acb68b6.png";